import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class HornetsNestSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.HORNETS_NEST;
}

export default HornetsNestSalvageableTileEntity;
